module.exports = __webpack_public_path__ + "static/media/181CO149.8b5159b1.jpg";